import {
  parseQuery,
  DefaultQueryParams,
  environmentBuilder,
  LobbyLiveConnection,
} from '@pascal/pascal-core';

import { gameName, socketLobbyPath } from '../enums/gameConfigsAndUrls';

import { lobbyService } from './LobbyService';

export class LobbyConnection extends LobbyLiveConnection {
  constructor(url) {
    super(url);
  }

  async sendLobbyGetInitialState() {
    const { [DefaultQueryParams.PartnerId]: partnerId } = parseQuery(window.location.search);

    try {
      this.executeConnections();
      await super.sendGetInitialState(partnerId);
    } catch (e) {
      await super.sendGetInitialState(partnerId);
    }
  }

  handleInitialResult(data) {
    // INITIAL
    lobbyService.onGetInitialStateResult.call(lobbyService, data);
    // INITIAL

    super.onReconnecting(lobbyService.handleReconnecting);
    super.onReconnected(lobbyService.handleReconnected);
    super.onClose(lobbyService.handleConnectionError);
  }

  executeConnections() {
    super.onGetInitialStateResult(this.handleInitialResult.bind(this));
    super.onRoundFinished(lobbyService.handleRoundFinished.bind(lobbyService));
    super.onLobbyUsersCount(lobbyService.handleLobbyUsersCount.bind(lobbyService));
  }
}
const { socketUrl } = environmentBuilder(gameName);

const url = (path) => ({ url: `${socketUrl}${path}` });

export const lobbyLiveConnection = new LobbyConnection(url(socketLobbyPath));
